import { render } from "./NewAccountModal.vue?vue&type=template&id=3280fb5a&ts=true"
import script from "./NewAccountModal.vue?vue&type=script&lang=ts"
export * from "./NewAccountModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__